export const STORE_PATH = {
  categoryBrand: 'categoryBrand',
  merchantCategory: 'merchantCategory',
  merchantBrand: 'merchantBrand',
  merchantActiveRule: 'merchantActiveRule',
  merchantCategoryRegex: 'merchantCategoryRegex',
  merchantBrandRegex: 'merchantBrandRegex',
  brandSynonym: 'brandSynonym',
  categoryBrandPath: 'categoryBrandPath',
  modal: 'modal'
}

export const DEBOUNCE_ONCHANGE_UI_ACTION_TIMEOUT = 500
